import { useEffect, useState } from 'react';
import { COOKIE_NOTICE_KEY, COOKIE_SETTINGS_EVENT, clearLegacyConsentCookie } from '@/lib/consent';
import { CookieNotice } from './CookieNotice';
import { CookieSettingsDialog } from './CookieSettingsDialog';
import './CookieConsent.css';

function readNoticeDismissed(): boolean {
  try {
    return localStorage.getItem(COOKIE_NOTICE_KEY) === 'dismissed';
  } catch {
    return false;
  }
}

function persistNoticeDismissed(): void {
  try {
    localStorage.setItem(COOKIE_NOTICE_KEY, 'dismissed');
  } catch {
    // Sem armazenamento (modo privado restrito) o aviso só volta na próxima visita.
  }
}

/**
 * O ponto único da conversa sobre cookies, montado na raiz para valer em todas
 * as rotas. O site só guarda o necessário, então não há o que perguntar: o aviso
 * informa uma vez, e o painel de preferências, que qualquer ponto da interface
 * reabre por `openCookieSettings()`, mostra o que é guardado.
 */
export function CookieConsent(): JSX.Element {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [noticeDismissed, setNoticeDismissed] = useState(readNoticeDismissed);

  useEffect(() => {
    const open = (): void => setSettingsOpen(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, open);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, open);
  }, []);

  useEffect(() => clearLegacyConsentCookie(), []);

  const dismissNotice = (): void => {
    persistNoticeDismissed();
    setNoticeDismissed(true);
  };

  return (
    <>
      {!noticeDismissed && <CookieNotice onDismiss={dismissNotice} />}
      <CookieSettingsDialog open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
}
